export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get in Touch
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Have questions? Ready to rent? We're here to help you get on the road.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-teal-600 to-cyan-600 rounded-2xl p-8 md:p-10 text-white">
              <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Email Us</h4>
                    <a 
                      href="mailto:wayne@basicrentals.info" 
                      className="text-white/90 hover:text-white transition-colors cursor-pointer"
                    >
                      wayne@basicrentals.info
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Response Time</h4>
                    <p className="text-white/90">We typically respond within 24 hours</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg flex-shrink-0">
                    <i className="ri-calendar-check-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Availability</h4>
                    <p className="text-white/90">Monday - Saturday, 8 AM - 6 PM</p>
                  </div>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-white/20">
                <p className="text-sm text-white/80 leading-relaxed">
                  Whether you're a rideshare driver, delivery worker, or someone who needs reliable transportation, 
                  we're committed to getting you behind the wheel quickly and affordably.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 md:p-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Us?</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Quick Approval</h4>
                    <p className="text-sm text-gray-600">Fast processing to get you on the road ASAP</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Flexible Terms</h4>
                    <p className="text-sm text-gray-600">Weekly rentals with easy extension options</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">No Hidden Fees</h4>
                    <p className="text-sm text-gray-600">Transparent pricing you can trust</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Maintained Fleet</h4>
                    <p className="text-sm text-gray-600">Regular service keeps our cars reliable</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Support When Needed</h4>
                    <p className="text-sm text-gray-600">We're here to help if issues arise</p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <a
                  href="mailto:wayne@basicrentals.info"
                  className="block w-full px-6 py-3 bg-teal-600 text-white text-center font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Email Us Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}